module.exports = __webpack_public_path__ + "static/media/12.f23b6bbd.jpg";